import { Redirect } from 'expo-router';

import SimulateIncomingAch from '../../../banking/components/incoming-ach-simulation/SimulateIncomingAch';
import { IS_PRODUCTION } from '../../../config/FruitfulEnvironment';

const SimulateIncomingAchScreen = () => {
    if (IS_PRODUCTION) {
        return <Redirect href="/home/banking" />;
    }

    return <SimulateIncomingAch />;
};

export default SimulateIncomingAchScreen;
